import {
  getIsOdd,
  getIsOnlyReadElement,
  getTaskFromLookahead
} from '../common/validators';
import {
  prepareUIElements,
  registerTaskCallbacks,
  setupGlobalHandlers
} from './utils';
import dropdownHTML from '../../components/dropdownHTML';
import TooltipHTML from '../../../TooltipHTML';
import { getCompanyTextColor } from '../../../../utils';

const renderCompanies = (props) => {
  setupGlobalHandlers();

  const {
    column,
    activities,
    gantt,
    t,
    onlyRead,
    task,
    subs,
    callbackOnClickCreate,
    callbackOnClickRemove,
    callbackOnSelection,
    mainObject,
    options
  } = props;

  if (!task.isTask && gantt) return '';

  const taskFromLookahead = getTaskFromLookahead(activities, gantt, task.id);
  const { subtradeRole } = gantt;
  const isOnlyReadElement = getIsOnlyReadElement(onlyRead, task, subtradeRole);
  const isOdd = getIsOdd({ gantt, task }, 'subcontractId');
  const selectedObject = mainObject || task;
  const optionsList = options || subs;
  const selectedSub = optionsList.find(
    (companies) => String(companies.id) === String(selectedObject.subcontractId)
  );

  registerTaskCallbacks(task.id, task, {
    taskFromLookahead,
    column,
    gantt,
    callbackOnSelection,
    callbackOnClickCreate,
    callbackOnClickRemove
  });

  const { placeholderHtml, optionsListHtml, createBtnHtml, removeBtnHtml } =
    prepareUIElements({
      selectedObject,
      optionsList,
      isOnlyReadElement,
      t,
      column
    });

  const dropdownContent = `
    <ul class="options-list" onscroll="event.stopPropagation()">
      ${createBtnHtml}
      ${optionsListHtml}
      ${removeBtnHtml}
    </ul>
  `;

  if (task.modificationSource === 'pending') {
    const selectedContent = selectedSub
      ? `
       <div
            style="color: ${getCompanyTextColor(selectedSub?.color)}; background-color: ${selectedSub?.color}">
            <div>
              ${selectedSub?.name}
            </div>
        </div>
      `
      : `<div style="width: 100%; height: 100%;">&nbsp;</div>`;

    const contentWithTooltip = TooltipHTML({
      text: t('activity_pending_sir_actions_tooltip'),
      container: selectedContent,
      task_id: task.id,
      name: 'subcontractId',
      gantt: gantt,
      customClass: 'TooltipHTML--pending'
    });

    return `
      <div 
        class="${isOdd ? 'odd-col' : 'non-odd-col'} pending-task"
        style="cursor: not-allowed !important; height: 100%;"
        data-task-id="${task.id}" 
        data-column-name="${column.name}">
          ${contentWithTooltip}
      </div>
    `;
  }

  const dropdown = dropdownHTML({
    trigger: placeholderHtml,
    content: dropdownContent,
    width: column?.width,
    isReadOnly: isOnlyReadElement,
    id: `companies-dropdown-${task.id}`,
    customClass: `custom-companies-dropdown`,
    searchable: true,
    searchPlaceholder: selectedSub?.name
  });

  return `
    <div 
      class="${isOdd ? 'odd-col' : 'non-odd-col'}"
      data-task-id="${task.id}"
      data-column-name="${column.name}">
      ${dropdown}
    </div>
  `;
};

export default renderCompanies;
